/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import SidebarContentContainer from '../../containers/SidebarContentContainer';

import styles from './Sidebar.module.scss';

const MobileSidebar = React.memo((menuActived) => {
  return (
    <div
      className={`${menuActived.menuActived ? styles.opened : ''} ${styles.sidebar_mobile_wrapper}`}
    >
      <aside className={styles.sidebar_mobile}>
        <SidebarContentContainer />
      </aside>
    </div>
  );
});

MobileSidebar.propTypes = {
  menuActived: PropTypes.bool,
};

MobileSidebar.defaultProps = {
  menuActived: undefined,
};

export default MobileSidebar;
